import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/medium_msu_emergency_medical_tech1_0ab00600de.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_Trainee_9f1a7b0249.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_Subba_3ecad8c763.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_Pema_Nam_7c96ae1709.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_Sarala_Pandey_0efd209edd.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_Kabita_0f8468e819.webp";

const Img1 = "https://cdn.msu.edu.in/art_1_ef194c9b71.webp";
const Img2 = "https://cdn.msu.edu.in/op_2_2f22578fd6.webp";
const Img3 = "https://cdn.msu.edu.in/op3_908ee1d700.webp";
const Img4 = "https://cdn.msu.edu.in/opto_660d943197.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const boData = {

    heroSection: {
        breadcrumb: [
            { name: "Home", url: "/" },
            { name: "Industry Co-led UG Programmes", url: "/industry-co-led-ug-programmes" },
            { name: "Bachelor of Optometry", url: "" }
        ],
        bannerImg: "https://img.youtube.com/vi/pkv9d1kZcDQ/hqdefault.jpg",
        title: "Bachelor of Optometry",
        poweredBy: {
            text: "Industry Skilling Partner",
            logo: EMVERSITY
        },
        duration: "5 Year Undergraduate Degree Programme",
        description:
            "Learn about General Anatomy, General Pharmacology, Ocular Pharmacology, Dispensing Optics and more.",

        stats: [
            {
                value: "Up to 70%",
                label: "Practical Curriculum"
            },
            {
                value: "Paid",
                label: "On-the-job learning"
            },
            {
                value: "100%",
                label: "Placement Assistance"
            }
        ],

        buttons: {
            download: "Download Brochure",
            enroll: "Enroll Now"
        },

        video: {
            thumbnail: "https://img.youtube.com/vi/pkv9d1kZcDQ/hqdefault.jpg",
            buttonText: "Watch Programme Video",
            url: "https://www.youtube.com/embed/pkv9d1kZcDQ"
        }
    },

    aboutSection: {
        tag: "ABOUT THE PROGRAMME",
        title: "Optometry Programme for Future Eye Care Specialists",
        description: [
            "The Bachelor of Optometry is a five-year undergraduate programme that trains students to become primary eye care professionals skilled in diagnosing refractive errors, prescribing corrective lenses, detecting ocular diseases and providing pre- and post-operative care for ophthalmic procedures. Students learn refraction techniques, contact lens fitting, binocular vision assessment, low vision rehabilitation and the use of advanced ophthalmic diagnostic instruments.",
            "This program at Medhavi Skills University is delivered through a unique partnership model: MSU provides the academic framework, degree conferral, examinations and campus infrastructure, while Emversity delivers the industry-skilling component, including AR/VR simulation-based training, employer-co-designed curriculum modules, structured clinical internships and placement assistance through its network of 500+ healthcare employer partners."
        ],
        stats: [
            { value: "Up to 70%", label: "Practical Curriculum" },
            { value: "Paid", label: "On-the-job learning" },
            { value: "100%", label: "Placement Assistance" }
        ],
        approvals: [
            "UGC Approved",
            "NEP 2020 Aligned",
            "Govt. Scholarships Available"
        ],
        journeyTitle: "Your 5-Year Journey",
        journey: [
            {
                phase: "YEAR 1",
                title: "Biomedical Foundations",
                description: "Build a strong scientific base with core concepts in human biology, vision science and healthcare fundamentals."
            },
            {
                phase: "YEAR 2",
                title: "Core Optometric Sciences",
                description: "Develop clinical understanding through vision assessment, disease diagnosis and hands-on optometric practices."
            },
            {
                phase: "YEAR 3",
                title: "Advanced Optometry & Specialisations",
                description: "Gain specialised expertise and real-world exposure through advanced care, research and clinical training."
            },
            {
                phase: "YEAR 4",
                title: "Clinical Practice & Professional Readiness",
                description: "Transition from classroom to clinic with advanced training and real patient exposure."
            },
            {
                phase: "YEAR 5 (FINAL PHASE)",
                title: "On-the-Job Learning",
                description: "Up to 12 months of paid full-time experience in independent case handling and industry-ready practice."
            },
            {
                phase: "GRADUATE",
                title: "Bachelor of Optometry",
                description: "Industry-ready eye care professional"
            }
        ]
    },

    offeringSection: {
        tag: "OUR OFFERING",
        title: {
            first: "Comprehensive",
            highlight: "Undergraduate Optometry Education"
        },
        description:
            "We offer a UGC-approved, 5-year full-time undergraduate degree of Bachelor of Optometry at Medhavi Skills University, Sikkim. It is an industry-aligned healthcare degree designed to build strong optometry skills and prepare students for diverse roles.",
        learningBox: {
            title: "Key Areas of Learning",
            points: [
                "Physical Optics",
                "General Pharmacology",
                "Ocular Pharmacology",
                "Behavioral Health Psychology",
                "Paediatric Optometry",
                "Low Vision Care and Rehabilitation"
            ]
        },
        image: "https://cdn.msu.edu.in/optometry_image_3_57f75e9433.webp"
    },

    whyEMT: {
        tag: "WHY OPTOMETRY. WHY NOW.",
        title: "Bridging the Gap in India's Eye Care Workforce",
        description:
            "The Bachelor of Optometry programme aligns with these industry trends, offering a curriculum that integrates theory with hands-on training to prepare future-ready healthcare professionals.",
        stats: [
            {
                value: "1 Billion",
                text: "Cases of vision impairment are preventable or yet to be addressed worldwide, highlighting a critical gap in eye care services (WHO).",
            },
            {
                value: "~40,000",
                text: "Registered optometrists are practicing in India but demand exceeds ~100,000, showing a significant shortfall and immense job opportunities for qualified professionals.",
            },
        ],
    },

    msuAdvantages: {
        tag: "MSU ADVANTAGES",
        title: "Programme by Emversity, Delivered at MSU Campus",
        description:
            "Your edge at Medhavi Skills University, where real-world learning, industry exposure and future-ready skills come together.",
        cards: [
            {
                number: "01",
                text: "Only university in Sikkim aligned with paid On-the-Job-Learning embedded curriculum for practical learning.",
            },
            {
                number: "02",
                text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships.",
            },
            {
                number: "03",
                text: "Well-equipped optometry lab, advanced training setups and hands-on field training.",
            },
        ],
        pointerTitle: "Highlights from The Programme:",
        highlights: [
            "Programme aligned with NEP 2020, focused on Learning Outcome Based Education",
            "Up to 70% practical based curriculum",
            "Paid On-the-Job Learning (OJL)",
            "Industry-aligned curriculum & hands-on learning",
            "Learn from seasoned optometry professionals",
            "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
            "Opportunity to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
            "Engage with industry experts to get invaluable insights and real-world perspectives"
        ],
        image: "https://cdn.msu.edu.in/msu_advantages_8519d5e66d_d99047931a.webp",
    },

    CTA: {
        title: "Step into the World of Vision Care with Emversity's",
        highlights: "Bachelor of Optometry",
        url: "#",
        btnName: "Apply Now"
    },

    onJobtrainningData: {
        tag: "ON-THE-JOB LEARNING",
        title: "Practical Industry Exposure",
        description: "At Medhavi Skills University, On-the-Job Learning (OJL) enables students to gain real industry experience and earn a stipend while they learn.",
        images: [
            { id: 1, src: OJLImg1, alt: "Pranita Pradhan at CRH Manipal, Gangtok" },
            { id: 2, src: OJLImg2, alt: "Kunsang Dolma Tamang at Mukherjee Hospital, Siliguri" },
            { id: 3, src: OJLImg3, alt: "Sancha Rani Subba at Anukul Diagnostic, Namchi" },
            { id: 4, src: OJLImg4, alt: "Pema Namgyal Bhutia at Ruchi Diagnostic, Gangtok" },
            { id: 5, src: OJLImg5, alt: "Sarala Pandey at District Hospital, Singtam" },
            { id: 6, src: OJLImg6, alt: "Kabita Karki at Prashanti Diagnostic, Singtam" }
        ]
    },

    addtionSkill: {
        courseSections: {
            AdditionalSkills: {
                tag: "BONUS CERTIFICATIONS",
                title: "Additional Skills Certifications",
                description: "At Medhavi Skills University, students have the opportunity to gain credible Skill Certifications like IACLEs and more. These certifications, earned alongside the degree, enhance credibility, strengthen industry relevance and prepare students for employment with nationally and globally recognised credentials.",
                image: {
                    url: "https://cdn.msu.edu.in/small_DSC_00555_1_1_32e0f68011.jpg",
                    alternativeText: "Skill Certification"
                },
                items: [
                    { id: 1, text: "IACLEs and Industry-Recognised Certifications", icon: Icon1 },
                    { id: 2, text: "Cambridge English for Healthcare Professionals (CEFR Standards)", icon: Icon2 },
                    { id: 3, text: "Nationally & Globally Recognised", icon: Icon1 }
                ],
                button: { text: "Apply Now", link: "/apply" }
            }
        }
    },

    DoExperienceLearndata: {
        tag: "INFRASTRUCTURE",
        title: "Do-Experience-Learn",
        description: "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities.",
        images: [
            { id: 1, src: Img1, size: "large", alt: "Classrooms" },
            { id: 2, src: Img2, size: "large", alt: "Optometry Labs" },
            { id: 3, src: Img3, size: "small", alt: "Phoropters" },
            { id: 4, src: Img4, size: "small", alt: "Eye Testing Equipments" },
            { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
        ],
    },

    studentStoriesData: {
        title: "Medhavians Speak",
        subText: "These stories reflect what happens when learning goes beyond theory. From hands-on training to real-world exposure, our students build skills that translate directly into careers.",
        students: [
            { name: "Radhika Chettri", image: Student2, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4" },
            { name: "Pratik Chettri", image: Student3, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4" },
            { name: "Suhana Sharma", image: Student4, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4" },
            { name: "Hissey Bhutia", image: Student1, videLink: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4", shortUrl: "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4" },
        ],
    },

    eligibility: {
        tag: "ELIGIBILITY",
        title: "Who Can Apply?",
        description: "12th Pass (10+2) with Physics, Chemistry and Biology/Mathematics as core subjects.",
        button: { text: "Apply Now", url: "" },
        items: [
            {
                title: "12th Pass - Science Stream",
                text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the Bachelor of Optometry programme.",
            },
        ],
    },

    careerProspects: {
        tag: "CAREER PROSPECTS",
        heading: "Career Prospects",
        description: "Access a wide range of career opportunities in optometry, driven by rising eye care needs in India.",
        roles: [
            "Clinical Optometrist",
            "Hospital Optometrist",
            "Pediatric Optometrist",
            "Contact Lens Specialist",
            "Vision Therapy Specialist",
            "Low Vision Rehabilitation Specialist",
            "Optical Retail Manager",
            "Ophthalmic Assistant",
            "Corporate Optometrist",
            "Sports Vision Specialist",
            "Academic Lecturer / Tutor",
            "Research Associate",
            "Public Health Optometrist",
            "Private Practice Owner",
            "Medical Equipment / Lens Industry Consultant"
        ]
    },

    curriculumStructure: {
        label: "WHAT YOU WILL LEARN",
        heading: "Curriculum Structure",
        description: "Step into a future-focused learning environment with industry-oriented programmes designed to build practical skills, real-world readiness and broad career opportunities across disciplines.",
        semesters: [
            {
                name: "Semester 1",
                title: "Building Foundations in Vision Science and Optometric Basics",
                description: "This semester introduces students to the core scientific and professional foundations in Vision Science and Optometric Practice. Subjects such as general Anatomy, General Physiology, General Biochemistry, Physical Optics help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "General Anatomy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "General Physiology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "General Biochemistry", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Physical Optics", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Mathematics & Geometrical Optics-I", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Introduction to Optometry", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Nutrition", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Communication", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Clinical Optometry I", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" }
                ]
            },
            {
                name: "Semester 2",
                title: "Strengthening Ocular Anatomy and Clinical Fundamentals",
                description: "This semester builds on the foundation by moving into applied learning and core discipline-specific principles in Vision Science and Optometric Practice. Subjects such as general Pharmacology, General Pathology, Ocular & Related Neuroanatomy, Ocular & Related Neurophysiology help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "General Pharmacology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "General Pathology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Ocular & Related Neuroanatomy", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Ocular & Related Neurophysiology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Ocular Biochemistry", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Geometrical Optics-II", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Basics of Computers", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Clinical Optometry-II", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
                ]
            },
            {
                name: "Semester 3",
                title: "Expanding Understanding of Ocular Disease and Visual Optics",
                description: "This semester deepens applied understanding and introduces more specialized content in Vision Science and Optometric Practice. Subjects such as general and Ocular Microbiology, Ocular Pharmacology, Visual Optics - I, Optometric Optics help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "General and Ocular Microbiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Ocular Pharmacology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Visual Optics – I", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Optometric Optics", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Ocular Disease – I", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Indian Medicine and Telemedicine", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Clinical Optometry – III", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
                ]
            },
            {
                name: "Semester 4",
                title: "Advancing Visual Assessment and Diagnostic Practice",
                description: "This semester strengthens advanced clinical, operational, or managerial competence in Vision Science and Optometric Practice. Subjects such as optometric Instruments, Clinical Examination of Visual System, Visual Perception and Psychophysics, Visual Optics - II help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "Optometric Instruments", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Clinical Examination of Visual System", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Visual Perception and Psychophysics", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Visual Optics – II", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Ocular Disease – II", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Behavioral Health Psychology", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Introduction to Quality & Patient Safety", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
                    { name: "Clinical Optometry – IV", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
                ]
            },
            {
                name: "Semester 5",
                title: "Deepening Expertise in Paediatric, Geriatric, and Dispensing Optics",
                description: "This semester focuses on specialized practice, advanced intervention, and discipline-specific application in Vision Science and Optometric Practice. Subjects such as systemic Disease, Dispensing Optics, Geriatric Optometry, Paediatric Optometry help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "Systemic Disease", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Dispensing Optics", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Geriatric Optometry", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Paediatric Optometry", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Diagnostics and Therapeutics of Anterior Segment Diseases", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Innovation and Technology", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Clinical Optometry – V", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
                ]
            },
            {
                name: "Semester 6",
                title: "Broadening Specialized Care in Contact Lens, Low Vision, and Binocular Vision",
                description: "This semester brings together advanced learning, research awareness, and multidisciplinary application in Vision Science and Optometric Practice. Subjects such as contact Lens - I, Low Vision Care and Rehabilitation, Binocular Vision - I, Diagnostics and Therapeutics of Posterior Segment Diseases help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester is designed to connect theory with practice while building confidence, accuracy, and readiness for advanced study.",
                subjects: [
                    { name: "Contact Lens – I", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Low Vision Care and Rehabilitation", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Binocular Vision – I", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Diagnostics and Therapeutics of Posterior Segment Diseases", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Optometry and Multidisciplinary Aspects of Health", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Research Methodology & Biostatistics", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Clinical Optometry – VI", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
                ]
            },
            {
                name: "Semester 7",
                title: "Integrating Community Eye Health, Ethics, and Research Practice",
                description: "This semester emphasizes internship, clinical posting, or industry immersion in Vision Science and Optometric Practice. Subjects such as contact Lens - II, Binocular Vision - II, Public Health & Epidemiology, Law and Professional Ethics - Optometry help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester also includes practical exposure and applied learning experiences that support the transition from classroom learning to professional practice.",
                subjects: [
                    { name: "Contact Lens – II", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Binocular Vision – II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Public Health & Epidemiology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Law and Professional Ethics – Optometry", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Community Eye Health", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Clinical Optometry – VII", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
                    { name: "Research Project – I", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
                ]
            },
            {
                name: "Semester 8",
                title: "Preparing for Professional Practice, Tele-Optometry, and Workplace Readiness",
                description: "This semester consolidates internship experience, placement readiness, and value-added learning in Vision Science and Optometric Practice. Subjects such as Occupational Optometry, Practice Management, Community Eye Health and Tele-optometry, Data Science for Healthcare help students build conceptual clarity, technical understanding, and discipline-specific competence. The curriculum encourages steady progression from academic knowledge to applied learning, supporting stronger analytical skills, professional discipline, and workplace readiness. The semester also includes practical exposure and applied learning experiences that support the transition from classroom learning to professional practice.",
                subjects: [
                    { name: "Occupational Optometry", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "Practice Management", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "Community Eye Health and Tele-optometry", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Data Science for Healthcare", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
                    { name: "Clinical Optometry – VIII", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
                    { name: "Research Project – II", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" }
                ]
            },
            {
                name: "Semester 9 & 10",
                title: "Transitioning to Professional Practice",
                description: "The final phase of the programme provides students with structured exposure to professional healthcare environments, enabling them to apply their academic learning in real-world settings. Through guided clinical experience and practical engagement, students strengthen their technical competencies, refine patient interaction skills, and gain a deeper understanding of professional responsibilities. This stage helps consolidate learning and supports a smooth transition from student life to professional practice.",
                subjects: [
                    { name: "B. Optom Internship – I", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "B. Optom Internship – II", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" }
                ]
            },
            {
                name: "Value Addition",
                title: "Value-Added Learning Opportunities",
                description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
                keySubjectsLabel: "Key Features",
                subjects: [
                    { name: "Skill certifications", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
                    { name: "One workshop per semester", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
                    { name: "One industry visit per semester", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
                    { name: "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" }
                ],
                learningOutcomes: [
                    "Gain real-world experience through the Red.Health Network internship",
                    "Execute industry-based projects in healthcare settings",
                    "Complete a capstone project and dissertation",
                    "Transition confidently into healthcare management roles",
                    "Prepare professionally through CV launch and career readiness activities"
                ]
            }
        ]
    },

    faq: {
        id: 103,
        title: "Bachelor of Optometry",
        FAQ: [
            {
                id: 1,
                Question: "What is the university's role and what is Emversity's role?",
                Answer: "MSU manages all academic matters — admissions, examinations, marksheets, transcripts and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees."
            },
            {
                id: 2,
                Question: "Is placement or internship stipend guaranteed?",
                Answer: "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution."
            },
            {
                id: 3,
                Question: "Is this program recognised and is it full-time?",
                Answer: "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university."
            },
            {
                id: 4,
                Question: "How do I apply?",
                Answer: "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details and application deadlines, please contact the MSU admissions office directly."
            },
            {
                id: 5,
                Question: "What is the Head Start Programme?",
                Answer: "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships."
            },
            {
                id: 6,
                Question: "Is this programme NCAHP aligned?",
                Answer: "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus."
            }
        ]
    },

    coursePrice: { price: "₹10,00,000" }
};